'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ContanctUsForm = require('./ContanctUsForm');

var _ContanctUsForm2 = _interopRequireDefault(_ContanctUsForm);

var _reduxForm = require('redux-form');

var _validation = require('shared/utils/validation');

var _userDataActions = require('../../../actions/userDataActions');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var validate = function validate(values) {
  var errors = {};

  _validation.validation.lengthValidation(values, 'name', errors, 100);

  _validation.validation.requiredFieldValidation(values, 'name', 'Please enter name', errors);

  _validation.validation.whitespacesValidation(values, 'name', 'Please enter name', errors);

  _validation.validation.patternValidation(values, 'email', _validation.emailPattern, 'Invalid email address', errors);

  _validation.validation.requiredFieldValidation(values, 'email', 'Please enter email', errors);

  _validation.validation.whitespacesValidation(values, 'email', 'Please enter email', errors);

  _validation.validation.oddSpacesPattern(values, 'email', 'Just one space allowed between 2 words in the middle of text', errors);

  _validation.validation.phoneNumberValidation(values, 'phone', 'Invalid phone format', errors);

  _validation.validation.lengthValidation(values, 'message', errors, 500);

  _validation.validation.requiredFieldValidation(values, 'message', 'Please enter message', errors);

  _validation.validation.whitespacesValidation(values, 'message', 'Please enter message', errors);

  return errors;
};

exports.default = (0, _reduxForm.reduxForm)({
  form: 'ContactUsForm',
  validate: validate,
  onSubmit: function onSubmit(values, dispatch, props) {
    props.modalClose();
    dispatch((0, _userDataActions.contactUsRequest)(values));
  }
})(_ContanctUsForm2.default);